import React from "react";

const CustomSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  checkedChildren = "ON",
  unCheckedChildren = "OFF",
  variant = "hubs",
}) => {
  const CONTAINER_CLASS = {
    hubs: "w-[60px] h-7",
    "create-session": "w-[50px] h-5",
    "spoilt-milk": "w-[60px] h-7",
  };

  const UNCHECKED_CLASS = {
    hubs: "bg-light-grey",
    "create-session": "bg-light-grey",
    "spoilt-milk": "bg-[#949494]",
  };

  const CHILDREN_TEXT_SIZE = {
    hubs: "text-xs text-dark-gray",
    "create-session": "text-10 text-dark-gray",
    "spoilt-milk": `text-xs ${checked ? "text-primary" : "text-white"}`,
  };

  const THUMB_CLASS = {
    hubs: "w-5 h-5",
    "create-session": "w-[14px] h-[14px]",
    "spoilt-milk": "w-5 h-5 text-white",
  };

  const TRANSLATE_CLASS = {
    hubs: "translate-x-8",
    "create-session": "translate-x-7",
    "spoilt-milk": "translate-x-8",
  };

  const THUMB_BG_CLASS = {
    hubs: checked
      ? `bg-primary ${TRANSLATE_CLASS[variant]}`
      : "bg-dark-gray translate-x-0",
    "create-session": checked
      ? `bg-primary ${TRANSLATE_CLASS[variant]}`
      : "bg-dark-gray translate-x-0",
    "spoilt-milk": checked
      ? `bg-primary ${TRANSLATE_CLASS[variant]}`
      : "bg-white translate-x-0",
  };

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`
        relative inline-flex items-center p-1 rounded-full transition-all duration-400 ease-in-out
        ${CONTAINER_CLASS[variant]}
        ${checked ? "bg-primary-20" : UNCHECKED_CLASS[variant]}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
      `}
    >
      <div className="absolute inset-0 flex items-center justify-between px-2">
        {checkedChildren && (
          <span
            className={`
            font-poppins font-medium transition-opacity duration-200 capitalize
            ${CHILDREN_TEXT_SIZE[variant]}
            ${checked ? "opacity-100" : "opacity-0"}
          `}
          >
            {checkedChildren}
          </span>
        )}

        {unCheckedChildren && (
          <span
            className={`
            font-poppins font-medium transition-opacity duration-200 capitalize
            ${CHILDREN_TEXT_SIZE[variant]}
            ${!checked ? "opacity-100" : "opacity-0"}
          `}
          >
            {unCheckedChildren}
          </span>
        )}
      </div>

      {/* thumb */}
      <div
        className={`
          rounded-full shadow-lg transition-transform duration-400 ease-in-out
          ${THUMB_CLASS[variant]}
          ${THUMB_BG_CLASS[variant]}
          ${disabled ? "" : "hover:shadow-xl"}
        `}
      />
    </button>
  );
};

export default CustomSwitch;
